import React, { useState, useEffect, useContext } from "react";
import BrandScore from "./BrandScore/BrandScore";
import {
  coreAttributesDataTransform,
  getSummaryPrompt,
  mergeChangeActions,
  getLLMInfo,
} from "../../../utils/helpers";
import CoreAttributes from "./CoreAttributes/CoreAttributes";
import classes from "./DashboardComponent.module.css";
import AIGenerated from "../../../Component/AIGenerated/AIGenerated";
import CategoryDimensions from "./CategoryDimensions/CategoryDims";
import PositiveAttributes from "./PositiveAttribute/PositiveAttribute";
import NegativeAttributes from "./NegativeAttribute/NegativeAttribute";
import Competitors from "./Competitors/Competitors";
import Source from "./Source/Source";
import {
  fetchGeminiAPI,
  getRealtimeActions,
  getSourcesWithAlias,
} from "../../../services/apiService";
import Spinner from "../../../Component/Spinner/Spinner";
import { AuthContext } from "../../../context/auth-context";
import Taxonomy from "./Taxonomy/Taxonomy";
import RealtimeActions from "./ActionComponent/RealtimeActions";
import { createDomainUrlMapping } from "./ActionComponent/ActionModal";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import AttributeBars from "./Attributes/Attributes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SecondaryCategories from "./SecondaryCategories/SecondaryCategories";
import CustomDateFilter from "../common/CustomDateFilter";

const BrandProductOverview = ({
  indexScoreMetaData,
  compIndexScoreMetaData,
  indexScoreDataForLineChart,
  domain,
  brandProductCategory,
  brandProduct,
  type,
  compCoreAttributes,
  brandDomains,
  compCategoryDimensions,
  positiveAttGraphData,
  pastPositiveAttGraphData,
  negativeAttGraphData,
  pastNegativeAttGraphData,
  compBrandIndexScore,
  pastCompBrandIndexScore,
  pastCompCoreAttributes,
  pastCompCategoryDimensions,
  categoryDimensionRatingSource,
  coreAttSourceData,
  reachSourceData,
  sentimentSourceData,
  brandProductInfo,
  frequency,
  sourceFullUrls,
  productTaxonomyData,
  selectedInput,
  selectedInputIds,
  positiveAttSource,
  negativeAttSource,
  sourceURLIds,
  secondaryCategoryMetaData,
  fetchRealTimeActionsSources,
  startDate,
  endDate,
  activeTarget,
  updateCustomFilterState,
  handleClickShow,
  customDatesToDisplay,
  filteredCoreAttributeBaseResponse,
  filteredCategoryDimensionBaseResponse
}) => {
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;
  const customerId = user?.customer_id || 0;
  const [realtimeActions, setRealtimeActions] = useState([]);
  const [isActionsLoading, setIsActionsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const [summaries, setSummaries] = useState({
    positiveAttributes: null,
    negativeAttributes: null,
    indexScore: null,
    favorability: null,
    rank: null,
    brandPillars: null,
    purchaseCriteria: null,
    productDimensions: null,
    attributes: null,
  });

  const [loading, setLoading] = useState({
    positiveAttributes: null,
    negativeAttributes: null,
    indexScore: null,
    favorability: null,
    rank: null,
    brandPillars: null,
    purchaseCriteria: null,
    productDimensions: null,
    attributes: null,
  });

  const [errors, setErrors] = useState({
    positiveAttributes: null,
    negativeAttributes: null,
    indexScore: null,
    favorability: null,
    rank: null,
    brandPillars: null,
    purchaseCriteria: null,
    productDimensions: null,
    attributes: null,
  });

  const [abortControllers, setAbortControllers] = useState([]);

  // Helper to create a new AbortController
  const createAbortController = () => {
    const abortController = new AbortController();
    setAbortControllers((prevControllers) => [
      ...prevControllers,
      abortController,
    ]);
    return abortController;
  };

  const resetAbortControllers = () => {
    abortControllers.forEach((controller) => controller.abort());
    setAbortControllers([]);
  };

  let coreAttributesData =
    (compCoreAttributes &&
      coreAttributesDataTransform(compCoreAttributes, brandProduct)) ||
    [];

  let purchaseDimData =
    compCategoryDimensions &&
    coreAttributesDataTransform(compCategoryDimensions, brandProduct);
  let pastcoreAttributesData = coreAttributesDataTransform(
    pastCompCoreAttributes
  );
  let pastPurchaseDimData = coreAttributesDataTransform(
    pastCompCategoryDimensions
  );

  const filterDataByBrand = (data, brand) => {
    const filteredData = {};

    for (let property in data) {
      if (data[property].hasOwnProperty(brand)) {
        // Create a new object with brand and its score for each property
        filteredData[property] = { [brand]: data[property][brand] };
      }
    }

    return filteredData;
  };

  const getAttributesSummary = (type) => {
    if (
      type == "positive-attributes" &&
      positiveAttGraphData &&
      positiveAttGraphData.length
    ) {
      fetchAttributeData(
        positiveAttGraphData,
        pastPositiveAttGraphData,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "positive",
        frequency,
        fetchSummaryData,
        "positiveAttributes"
      );
    }

    if (
      type == "negative-attributes" &&
      negativeAttGraphData &&
      negativeAttGraphData.length
    ) {
      fetchAttributeData(
        negativeAttGraphData,
        pastNegativeAttGraphData,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "negative",
        frequency,
        fetchSummaryData,
        "negativeAttributes"
      );
    }

    if (
      type == "attributes" &&
      ((negativeAttGraphData && negativeAttGraphData.length) ||
        (positiveAttGraphData && positiveAttGraphData.length))
    ) {
      fetchAttributeData(
        positiveAttGraphData,
        negativeAttGraphData,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "attributes",
        frequency,
        fetchSummaryData,
        "attributes"
      );
    }

    if (
      type == "brand-pillars" &&
      coreAttributesData &&
      coreAttributesData.length
    ) {
      fetchMetricSummary(
        coreAttributesData,
        pastcoreAttributesData,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "brand pillars",
        frequency,
        fetchSummaryData,
        "brandPillars"
      );
    }

    if (
      type == "product-dimensions" &&
      productTaxonomyData &&
      productTaxonomyData.length
    ) {
      fetchMetricSummary(
        productTaxonomyData,
        undefined,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "product taxonomy",
        frequency,
        fetchSummaryData,
        "productDimensions"
      );
    }

    if (
      type == "purchase-criteria" &&
      purchaseDimData &&
      purchaseDimData.length
    ) {
      fetchMetricSummary(
        purchaseDimData,
        pastPurchaseDimData,
        currentFrequencyMapping,
        priorFrequencyMapping,
        brandProduct,
        "purchase criterias",
        frequency,
        fetchSummaryData,
        "purchaseCriteria"
      );
    }
  };

  const fetchMetricSummary = (
    currentMetricData,
    pastMetricData,
    currentFrequencyMapping,
    priorFrequencyMapping,
    brandProduct,
    type,
    frequency,
    fetchSummaryData,
    attributeType
  ) => {
    const currentData = currentMetricData;

    const priorData = pastMetricData;

    const finalData = {
      [`${currentFrequencyMapping[frequency || ""]
        } ${type} of ${brandProduct}`]: currentData,
      // [`${priorFrequencyMapping[frequency || ""]} ${type} of ${brandProduct}`]:
      //   priorData,
    };

    if (priorData) {
      finalData[
        `${priorFrequencyMapping[frequency || ""]} ${type} of ${brandProduct}`
      ] = priorData;
    }
    fetchSummaryData(finalData, attributeType);
  };

  // Function to handle fetching summary data for both positive and negative attributes
  const fetchAttributeData = (
    currentGraphData,
    pastGraphData,
    currentFrequencyMapping,
    priorFrequencyMapping,
    brandProduct,
    type,
    frequency,
    fetchSummaryData,
    attributeType
  ) => {
    const currentData = transformGraphData(currentGraphData);

    const priorData = transformGraphData(pastGraphData);

    let finalData = {};

    if (type == "attributes") {
      finalData = {
        [`${currentFrequencyMapping[frequency || ""]
          } positive attributes of ${brandProduct}`]: currentData,
        [`${currentFrequencyMapping[frequency || ""]
          } negative attributes of ${brandProduct}`]: priorData,
      };
    } else {
      finalData = {
        [`${currentFrequencyMapping[frequency || ""]
          } ${type} attributes of ${brandProduct}`]: currentData,
        [`${priorFrequencyMapping[frequency || ""]
          } ${type} attributes of ${brandProduct}`]: priorData,
      };
    }
    fetchSummaryData(finalData, attributeType);
  };

  const transformGraphData = (graphData) => {
    return (
      graphData?.map((obj) => ({
        "attribute-category": obj?.name,
        "attribute-category-signal-strength": obj?.value,
        attributes: obj?.altNames,
        totalSignlStrengths: obj?.signalStrengths,
      })) || []
    );
  };

  const brandIndexScore = filterDataByBrand(compBrandIndexScore, brandProduct);
  const pastBrandIndexScore = filterDataByBrand(
    pastCompBrandIndexScore,
    brandProduct
  );

  const currentFrequencyMapping = {
    Current: "Current",
    "3Days": "current 3 days average",
    "7Days": "current 7 days average",
    Month: "current 30 days average",
    "3Month": "current 90 days average",
  };

  const priorFrequencyMapping = {
    Current: "Prior",
    "3Days": "prior 3 days average",
    "7Days": "prior 7 days average",
    Month: "prior 30 days average",
    "3Month": "prior 90 days average",
  };

  const getBrandIndexPromptData = (property, label) => {
    return {
      [`${currentFrequencyMapping?.[frequency] || ""} ${property}`]: {
        ...brandIndexScore?.[label],
        category: brandProductCategory,
      },
      [`${priorFrequencyMapping?.[frequency] || ""} ${property}`]: {
        ...pastBrandIndexScore?.[label],
        category: brandProductCategory,
      },
    };
  };

  const getBrandIndexSummary = (data, mainDataKey, promptKey, summaryKey) => {
    if (data?.[mainDataKey]) {
      const data = getBrandIndexPromptData(promptKey, mainDataKey);
      fetchSummaryData(data, summaryKey);
    }
  };

  const fetchSummaryData = async (dataProp, propKey) => {
    setLoading((prev) => ({ ...prev, [propKey]: true }));
    setErrors((prev) => ({ ...prev, [propKey]: null }));

    const compReachScoreData = compBrandIndexScore?.Rank;

    try {
      const controller = createAbortController();
      const prompt = getSummaryPrompt(
        dataProp,
        propKey,
        compReachScoreData,
        brandProduct
      );
      let result = await fetchGeminiAPI(
        prompt,
        controller,
        undefined,
        undefined
        // "gpt-4o"
      );
      result = result["Gemini"][0];
      setSummaries((prev) => ({ ...prev, [propKey]: result }));
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        [propKey]: "Failed to generate summary",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, [propKey]: false }));
    }
  };

  useEffect(() => {
    const fetchActions = async () => {
      try {
        if (!selectedInputIds || !type) return;
        setIsActionsLoading(true);
        const { brandId, productId, personaId, llmIds, categoryIds, isCompanyUser,
          customerId, } =
          selectedInputIds;

        const payload = {
          personaIds: personaId,
          llmIds,
          ...(type === "Product" ? { productId } : { brandId }),
          timePeriod: frequency,
          categoryIds,
          startDate, endDate, isCompanyUser,
          customerId,
        };

        const { finalProcessedData } = await getRealtimeActions(payload);
        if (finalProcessedData && finalProcessedData?.length) {
          const dataMapping = ["Reach", "Sentiment", "Risk"].reduce(
            (acc, key) => {
              acc[key.toLowerCase()] =
                key == "Risk"
                  ? finalProcessedData?.[0]?.["Performance"]
                  : finalProcessedData?.[0]?.[key];

              return acc;
            },
            {}
          );

          setRealtimeActions(prepareRealtimeActionsData(dataMapping));
        }
      } catch (err) {
        console.error("Error fetching actions:", err);
      } finally {
        setIsActionsLoading(false);
      }
    };

    fetchActions();
  }, []);

  function prepareRealtimeActionsData(input) {
    const output = [];
    for (const [key, value] of Object.entries(input)) {
      if (Array.isArray(value)) {
        const descriptions = value.map((item) => ({
          text: item.title || item.mainTitle,
          additionalInfo: item.sources,
          rationale: item?.rationale,
          compTitles: item?.compTitles,
        }));

        output.push({
          number: value.length,
          title: key,
          descriptions,
        });
      }
    }

    return output;
  }

  useEffect(() => {
    resetAbortControllers();
    getBrandIndexSummary(
      brandIndexScore,
      "Brand Index Score",
      "Brand Index Score",
      "indexScore"
    );

    if (license_status == "Paid") {
      const metric = type == "Product" ? "product-dimensions" : "brand-pillars";
      const metrics = [
        // "positive-attributes",
        // "negative-attributes",
        metric,
        "purchase-criteria",
        "attributes",
      ];

      metrics.map((type) => {
        getAttributesSummary(type);
      });
    }
  }, [compBrandIndexScore]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const saveActions = async (actions) => {
    if (!actions || actions.length === 0) return;

    setIsLoading(true);

    try {
      const actionList = await Promise.all(
        actions.map(async (obj) => {

          return {
            title: obj?.text,
            rationale: obj?.rationale,
            brand: selectedInput?.brand || selectedInput?.product,
            persona: selectedInput?.persona,
            geography: selectedInput?.geography,
            market: selectedInput?.market,
            llm: selectedInput?.llm,
            isProduct: !!selectedInput?.product,
            sources: obj?.additionalInfo?.map((url) => ({
              domain_url: url,
              fullUrl: null,
            })),
            compTitles: obj?.compTitles,
          };
        })
      );

      const payload = {
        action_json: actionList,
        is_archived: 0,
        is_active: 1,
      };

      dispatch(createActionMetric(customerId, payload))
        .then(() => {
          dispatch(fetchActionMetrics(customerId))
            .then(() => {
              toast.success("Action Added!", { autoClose: 700 });
            })
            .catch(() => {
              toast.error("Failed to fetch updated metrics!", {
                autoClose: 700,
              });
            });
        })
        .catch(() => {
          toast.error("Something went wrong while creating actions!", {
            autoClose: 700,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error("Error processing actions:", error);
      setIsLoading(false);
      toast.error("Something went wrong!", { autoClose: 700 });
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Get LLM info using helper function - use same logic as payload
  // Use customDatesToDisplay (applied dates) instead of state dates
  const appliedStartDate = customDatesToDisplay?.startDate || startDate;
  const appliedEndDate = customDatesToDisplay?.endDate || endDate;
  const effectiveEndDate = activeTarget === "Recent" ? appliedEndDate : appliedStartDate;
  const llmInfo = getLLMInfo(indexScoreDataForLineChart, isChecked, appliedStartDate, effectiveEndDate);

  return (
    <div>

      {frequency === 'Custom' && <CustomDateFilter
        activeTarget={activeTarget}
        handleChange={updateCustomFilterState}
        customDatesToDisplay={customDatesToDisplay}
      />}

      <div style={{
        fontSize: "15px",
        marginLeft: '10px',
        marginRight: '10px',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '15px'
      }}>
        <label>
          <input
            style={{}}
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          &nbsp;
          {"Show Change Data"}
        </label>

        {llmInfo && (
          <div style={{
            // position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '6px 16px',
            backgroundColor: '#e3f2fd',
            border: '1px solid #90caf9',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: '#1565c0',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <span style={{ color: '#0d47a1', marginRight: '8px' }}>LLM:</span>
            {llmInfo}
          </div>
        )}

        <div style={{ width: '120px' }}></div>
      </div>


      <BrandScore
        customerId={customerId}
        reachSources={reachSourceData}
        sentimentSources={sentimentSourceData}
        selectedInput={selectedInput}
        domain={domain}
        indexScoreDataForLineChart={indexScoreDataForLineChart}
        brandProductCategory={brandProductCategory}
        brandProduct={brandProduct}
        type={type}
        brandIndexScore={brandIndexScore}
        pastBrandIndexScore={pastBrandIndexScore}
        brandProductInfo={brandProductInfo}
        errors={errors}
        loading={loading}
        summaries={summaries}
        indexScoreMetaData={indexScoreMetaData}
        frequency={frequency}
        sourceFullUrls={sourceFullUrls}
        sourceURLIds={sourceURLIds}
        isChecked={isChecked}
        handleClickShow={handleClickShow}
        compIndexScoreMetaData={compIndexScoreMetaData}
      />
      <p> </p>
      <Competitors
        brandDomains={brandDomains}
        compBrandIndexScore={compBrandIndexScore}
        pastCompBrandIndexScore={pastCompBrandIndexScore}
        compIndexScoreMetaData={compIndexScoreMetaData}
        isChecked={isChecked}
        handleClickShow={handleClickShow}
        selectedInput={selectedInput}
      />
      <p> </p>
      {/* {Boolean(secondaryCategoryMetaData.length) && (
        <SecondaryCategories
          secondaryCategoryMetaData={secondaryCategoryMetaData}
          brandDomains={brandDomains}
          brandProduct={brandProduct}
          reachSourceData={reachSourceData}
          sentimentSourceData={sentimentSourceData}
          sourceURLIds={sourceURLIds}
          selectedInput={selectedInput}
          customerId={customerId}
        />
      )} */}
      {/* <p> </p> */}

      {/* <PositiveAttributes
        positiveAttGraphData={positiveAttGraphData}
        pastPositiveAttGraphData={pastPositiveAttGraphData}
        getAttributesSummary={getAttributesSummary}
        errors={errors}
        summaries={summaries}
        loading={loading}
      />
      <NegativeAttributes
        negativeAttGraphData={negativeAttGraphData}
        pastNegativeAttGraphData={pastNegativeAttGraphData}
        getAttributesSummary={getAttributesSummary}
        errors={errors}
        summaries={summaries}
        loading={loading}
      /> */}
      <AttributeBars
        negativeAttributes={negativeAttGraphData}
        positiveAttributes={positiveAttGraphData}
        getAttributesSummary={getAttributesSummary}
        errors={errors}
        summaries={summaries}
        loading={loading}
        selectedInput={selectedInput}
        sources={negativeAttSource}
        customerId={customerId}
        sourceURLIds={sourceURLIds}
      />
      <p> </p>
      <div className={classes.section_summary}>
        {type == "Product" ? (
          <Taxonomy
            fetchRealTimeActionsSources={fetchRealTimeActionsSources}
            customerId={customerId}
            categories={productTaxonomyData}
            brandDomains={brandDomains}
            errors={errors}
            summaries={summaries}
            loading={loading}
            getAttributesSummary={getAttributesSummary}
            selectedInput={selectedInput}
            sources={[]}
            sourceURLIds={sourceURLIds}
            isChecked={isChecked}
          />
        ) : (
          <CoreAttributes
            fetchRealTimeActionsSources={fetchRealTimeActionsSources}
            customerId={customerId}
            brandDomains={brandDomains}
            coreAttributesData={coreAttributesData}
            pastcoreAttributesData={pastcoreAttributesData}
            getAttributesSummary={getAttributesSummary}
            errors={errors}
            summaries={summaries}
            loading={loading}
            selectedInput={selectedInput}
            sources={coreAttSourceData}
            sourceFullUrls={sourceFullUrls}
            sourceURLIds={sourceURLIds}
            isChecked={isChecked}
            filteredCoreAttributeBaseResponse={filteredCoreAttributeBaseResponse}
          />
        )}
      </div>
      <p> </p>
      <div className={classes.section_summary}>
        <CategoryDimensions
          fetchRealTimeActionsSources={fetchRealTimeActionsSources}
          brandDomains={brandDomains}
          purchaseDimData={purchaseDimData}
          pastPurchaseDimData={pastPurchaseDimData}
          getAttributesSummary={getAttributesSummary}
          errors={errors}
          summaries={summaries}
          loading={loading}
          selectedInput={selectedInput}
          sources={categoryDimensionRatingSource}
          customerId={customerId}
          sourceFullUrls={sourceFullUrls}
          sourceURLIds={sourceURLIds}
          isChecked={isChecked}
          filteredCategoryDimensionBaseResponse={filteredCategoryDimensionBaseResponse}
        />
      </div>
      <p> </p>
      <RealtimeActions
        isActionsLoading={isActionsLoading}
        realtimeActions={realtimeActions}
        saveActions={saveActions}
        isLoading={isLoading}
        selectedInput={selectedInput}
      />
      {/* <Source
        categoryDimensionRatingSource={categoryDimensionRatingSource}
        coreAttSourceData={coreAttSourceData}
        reachSourceData={reachSourceData}
        sentimentSourceData={sentimentSourceData}
        sourceFullUrls={sourceFullUrls}
      /> */}
      <ToastContainer />
    </div>
  );
};

export default BrandProductOverview;
